import { PRODUCT_LISTING_SET_PROP } from '../constants';
import { dataLayerViewModeChanged } from '../Services/Gtm.service';
import { get, post } from '../Services/http';

export const setProductListingType = (productListingType) => async (
  dispatch
) => {
  const res = await post('/api/products/listingtype', {
    productListingType,
  });
  if (res.ok) {

    dataLayerViewModeChanged(productListingType); //tracking

    dispatch(setProductListingProp('productListingType', productListingType));
  }
};

// Calls Clerk sort endpoint and updates product listing products
export const sortCurrentListingWithClerk = (sortBy, queryString) => (dispatch, getState) => {
  // Build URL for Clerk sorting; append current filters in queryString if provided
  let url = '/api/clerkio/sort';
  const qs = queryString || (window.location.search.substr(1) || '');
  const parts = [];
  if (qs && qs.trim() !== '') parts.push(qs);
  // Only add sort_by if it's not already present in the query string
  const hasSortParam = (() => {
    try {
      const sp = new URLSearchParams(qs);
      return sp.has('sort_by');
    } catch {
      return qs.split('&').some((p) => p.split('=')[0] === 'sort_by');
    }
  })();
  if (sortBy && !hasSortParam) parts.push(`sort_by=${encodeURIComponent(sortBy)}`);
  if (parts.length) url += `?${parts.join('&')}`;

  return get(url)
    .then((response) => response.json())
    .then((data) => {
      const products = Array.isArray(data?.products)
        ? data.products
        : Array.isArray(data)
        ? data
        : [];

      if (!products || products.length === 0) {
        // Avoid dispatching when there are no products to render
        return;
      }
      dispatch({
        type: PRODUCT_LISTING_SET_PROP,
        payload: { prop: 'products', value: products },
      });
    })
    .catch((ex) => dispatch(catchError(ex, (error) => searchError(error))));
};

const setProductListingProp = (key, value) => ({
  type: PRODUCT_LISTING_SET_PROP,
  payload: { prop: key, value: value }
});
